import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "entry" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "node" }, null, -1)
const _hoisted_4 = { class: "text-time" }
const _hoisted_5 = { class: "section-right" }
const _hoisted_6 = { class: "title-body mb-1" }
const _hoisted_7 = { class: "sub-title-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.logs, (data) => {
    return (_openBlock(), _createBlock("div", {
      class: "timeline",
      key: data.Id
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("p", _hoisted_4, _toDisplayString(`${_ctx.moment(data?.CreatedAt).format('DD MMM YYYY, HH:mm')} WIB`), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("p", _hoisted_6, _toDisplayString(data?.StatusPengirimanStatus), 1),
          _createVNode("p", _hoisted_7, _toDisplayString(data?.Keterangan), 1)
        ])
      ])
    ]))
  }), 128))
}